export function normalizePrice(
    price: number,
    tickSz: number | null | undefined,
): number {
    if (null == tickSz || tickSz <= 0 || !Number.isFinite(price)) return price;

    // 用十进制定点整数完成 HALF_UP，避免 2.5 这类非 10 次幂 tickSz
    // 被错误地按 0 位小数格式化，也避免浮点乘除造成边界漂移。
    const scale = Math.max(decimalPlaces(price), decimalPlaces(tickSz));
    const priceInt = toScaledInteger(price, scale);
    const tickInt = toScaledInteger(tickSz, scale);
    if (0n === tickInt) return price;

    const sign = priceInt < 0n ? -1n : 1n;
    const absolutePrice = priceInt < 0n ? -priceInt : priceInt;
    const absoluteTick = tickInt < 0n ? -tickInt : tickInt;
    const roundedLots = (2n * absolutePrice + absoluteTick) / (2n * absoluteTick);
    return scaledIntegerToNumber(sign * roundedLots * absoluteTick, scale);
}

function decimalPlaces(value: number): number {
    const [coefficient, exponentText] = Math.abs(value).toString().toLowerCase().split('e');
    const fractionLength = coefficient.includes('.') ? coefficient.length - coefficient.indexOf('.') - 1 : 0;
    const exponent = exponentText ? Number(exponentText) : 0;
    return Math.max(0, fractionLength - exponent);
}

function toScaledInteger(value: number, scale: number): bigint {
    const fixed = Math.abs(value).toFixed(scale);
    const digits = fixed.replace('.', '');
    return (value < 0 ? -1n : 1n) * BigInt(digits);
}

function scaledIntegerToNumber(value: bigint, scale: number): number {
    const negative = value < 0n;
    const digits = (negative ? -value : value).toString().padStart(scale + 1, '0');
    const plain = 0 === scale
        ? digits
        : `${digits.slice(0, -scale)}.${digits.slice(-scale)}`;
    return Number(negative ? `-${plain}` : plain);
}

export function normalizeSize(
    size: number,
    lotSz: number | null | undefined,
    minSz: number | null | undefined,
): number {
    if (null == lotSz || lotSz <= 0) return size;
    const floored = Math.floor(size / lotSz) * lotSz;
    if (null != minSz && minSz > 0 && floored < minSz) return 0;
    return Math.max(0, floored);
}
